package gr.tech.GRAttestation.sections.tables

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.GRAttestation.models.stores.STORE_STATUS
import gr.tech.GRAttestation.sections.admin.AdminTableContainer
import gr.tech.GRAttestation.styles.admin.AdminTableStickyColumn
import gr.tech.GRAttestation.styles.grstyles.DropdownLinkStyle
import gr.tech.GRAttestation.util.TimeUtils.formatDateOnly
import gr.tech.GRAttestation.util.formatCurrency
import gr.tech.models.skus.SkuDTO
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*

@Composable
fun AdminSKUsTable(
    skus: List<SkuDTO>,
    onView: (SkuDTO) -> Unit,
    onEdit: (SkuDTO) -> Unit,
    onDelete: (SkuDTO) -> Unit,
    onRestore: (SkuDTO) -> Unit,
) {
    AdminTableContainer() {
        Table(
            attrs = Modifier
                .classNames("table")
                .minWidth(1000.px)
                .height(100.percent)
                .fillMaxWidth()
                .toAttrs()
        ) {
            Thead(
                attrs = Modifier
                    .styleModifier {
                        property("table-layout", "fixed")
                    }
                    .toAttrs()
            ) {
                Tr {
                    listOf(
                        "ID",
                        "SKU / Model #",
                        "Description",
                        "Unit Price",
                        "# Per Receipt",
                        "Created",
                        "Created By",
                        "Updated",
                    ).forEach { header ->
                        Th(
                            attrs = Modifier.minWidth(100.px).classNames("col").toAttrs()
                        ) { Text(header) }
                    }
                    Th(
                        attrs = Modifier
                            .then(AdminTableStickyColumn.toModifier())
                            .width(150.px)
                            .toAttrs()
                    ) {
                        Text("Action")
                    }
                }
            }
            Tbody {
                if (skus.isNotEmpty()) {
                    skus.forEach { sku ->
                        AdminSKUTableRow(
                            sku = sku,
                            onView = { onView(it) },
                            onEdit = { onEdit(it) },
                            onDelete = { onDelete(it) },
                            onRestore = { onRestore(it) }
                        )
                    }
                } else {
                    repeat(1) {
                        AdminActivitySummaryRow(null)
                    }
                }
            }
        }
    }
}


@Composable
fun AdminSKUTableRow(
    sku: SkuDTO,
    onView: (SkuDTO) -> Unit,
    onEdit: (SkuDTO) -> Unit,
    onDelete: (SkuDTO) -> Unit,
    onRestore: (SkuDTO) -> Unit,
) {
    Tr {
        Td { Text(sku.id.toString()) }
        Td { Text(sku.sku) }
        Td { Text(sku.description) }
        Td { Text(formatCurrency(sku.unitPrice)) }
        Td { Text((sku.amountPerReceipt ?: "-").toString()) }
        Td {
            Span { Text(formatDateOnly(sku.createdAt)) }
            TableDateTimeTooltip(sku.createdAt)
        }
        Td { Text(sku.createdBy) }
        Td {
            Span { Text(formatDateOnly(sku.updatedAt)) }
            TableDateTimeTooltip(sku.updatedAt)
        }

        // Action column
        Td(
            attrs = Modifier
                .padding(.5.cssRem)
                .then(AdminTableStickyColumn.toModifier())
                .toAttrs()
        ) {
            Div(
                attrs = Modifier
                    .classNames("btn", "dropstart")
                    .padding(0.px)
                    .toAttrs()
            ) {
                Button(
                    attrs = Modifier
                        .classNames("btn", "btn-outline-secondary")
                        .toAttrs{
                            attr("data-bs-toggle", "dropdown")
                        }
                ) {
                    Text("Action")
                }
                Ul(
                    attrs = Modifier.classNames("dropdown-menu")
                        .toAttrs()
                ) {
                    Li {
                        Span(
                            attrs = DropdownLinkStyle.toModifier().classNames("dropdown-item")
                                .onClick { onEdit(sku) }
                                .toAttrs()
                        ) {
                            Text("Edit")
                        }
                    }
                    Li {
                        Span(
                            attrs = DropdownLinkStyle.toModifier().classNames("dropdown-item")
                                .onClick {
                                    if(sku.status == STORE_STATUS.DELETED.bit) {
                                        onRestore(sku)
                                    } else {
                                        onDelete(sku)
                                    }
                                }
                                .toAttrs()
                        ) {
                            if(sku.status == STORE_STATUS.DELETED.bit) {
                                Text("Restore")
                            } else {
                                Text("Delete")
                            }
                        }
                    }
                }
            }

        }
    }
}